
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Sample } from '../../components';

@Component({
    selector: 'app-dividers',
    imports: [Sample],
    templateUrl: './dividers.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dividers.scss'
})
export class Dividers {}
